import styled from 'styled-components/macro';
import FilterWrapper from 'styled/Page/FilterWrapper';

const CustomFilterWrapper = styled(FilterWrapper)`
  z-index: 5;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding-bottom: 2px;
`;

export default CustomFilterWrapper;
